import React, { useRef, useEffect, useState } from "react";
import "./GenericTableRow.css";
import ComingSoon from "../../AccountDetails/Nudges/comingSoonComp";

const GenericTableRow = ({ row, columns,allowSelection,selectedRows,setSelectedRows }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  // const [hasOverflow, setHasOverflow] = useState(false);
  // const contentRefs = useRef([]);
    // useEffect(() => {
  //   const anyOverflow = contentRefs.current.some(
  //     (el) => el && el.scrollWidth > el.clientWidth
  //   );
  //   setHasOverflow(anyOverflow);
  // }, [row]);

  const isRowSelected = (row) =>{
   return selectedRows.some((selected) => selected.id === row.id);}

  const handleToggleExpand = (e, tdData) => {
    e.preventDefault();
    e.stopPropagation();
    if (tdData?.expandable) {
      setIsExpanded((prev) => !prev);
      tdData?.onClickAction?.(tdData);
    }
  };

  if (row?.isPartialLoad) {
    return (
      <tr className="gtr-expanded-row">
      {row?.isPartialLoad}
      </tr>
    );
  }

  const toggleRow = (row) => {
    // console.log("toggleRow",row?.noProcessedItem)
    setSelectedRows((prev) =>
      isRowSelected(row)
        ? prev.filter((r) => r.id !== row.id) // remove row
        : [...prev, row?.noProcessedItem ? row?.noProcessedItem:row] // add entire row
    );
  };

   

  return (
    <>

    <tr className={`gtr-row ${row.is_read === false ? "gtr-row-unread" : ""} ${isExpanded ? "gtr-expanded" : ""}`}>

        



        {columns.map((col, idx) => {

          if ( allowSelection && col?.id === "generic-check-box") {
           return <td  className="gtr-cell" style={{width:"0.5rem",maxWidth:"0.5rem !important"}}><input type="checkbox" onClick={() => toggleRow(row)}  checked={isRowSelected(row)}/></td>
          }
          

        
          if (col.isTimeLine) {
            return (
              <td
                className="timeline-cell"
                key="timestamp"
                style={{ minWidth: col.width, maxWidth: col.width }}
              >
                <div className="timeline-track">
                  <div className="timeline-line top" />
                  <div className="timeline-dot"> {row[col?.id]}</div>

                  <div className="timeline-line bottom" />
                </div>
              </td>
            );
          }

          return (
            <td
              key={col.id}
              style={{ minWidth: col.width, maxWidth: col.width }}
              className={`gtr-cell ${row.is_read === false && idx==0 ? "gtr-unread" : ""}`}
        
              onClick={(e) => handleToggleExpand(e, row[col.id])}
            >
           
              <div className="gtr-cell-content-container" style={{display:"flex",flexDirection:"row", justifyContent:col?.alignment || "flex-start"}}>
                  {row[col.id]?.content ?? row[col.id]}
                  {row[col.id]?.expandable && (
                  <span>
                    <img
                      src={
                        isExpanded
                          ? "/img/contractRow.svg"
                          : "/img/expandRow.svg"
                      }
                      alt="toggle"
                      className="ml-2"
                    />
                  </span>
                )}
              </div>
                
            </td>
          );
        })}
      </tr>
      {isExpanded && row.isExpandedContent}
    </>
  );
};

export default GenericTableRow;
